"use client";

import React, { useState, useEffect } from "react";
import { ospThemes } from "@ospweb/sdk-ui";
import { KlineColumn } from "@/src/components/table/dashboard/columns/items/klineColumn";
import type { Kline } from "@/src/features/api/openApi";
import { useIsPc } from "@/src/hooks/useIsPc";

interface KlineColumnClientProps {
  data: Kline[];
  change: number;
}

/**
 * 客户端 KlineColumn 包装组件
 * 用于条件渲染，避免 SSR 时 window is not defined 错误
 */
export const KlineColumnClient: React.FC<KlineColumnClientProps> = ({
  data,
  change,
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isPc] = useIsPc();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // 服务端渲染占位符，客户端挂载后再渲染 KlineColumn
  if (!isMounted) {
    return <div data-testid="indices-sparkline" className="h-[29px] w-full" />;
  }

  return (
    <KlineColumn
      data={data}
      limit={1}
      width={isPc ? 110 : 96}
      height={29}
      change={change}
      excludeWhiteColor
      customKlineStyle={{
        redColor: ospThemes.colors.background_accent1_overlay100,
        greenColor: ospThemes.colors.background_accent2_overlay100,
        lineWidth: 1,
        gradientStopOpacity: 0.1,
      }}
    />
  );
};
